import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { Bandi } from './pages/Bandi';
import { Candidature } from './pages/Candidature';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { BandoDetail } from './pages/BandoDetail';
import { CandidaturaDetail } from './pages/CandidaturaDetail';
import { GestioneValutatori } from './pages/GestioneValutatori';
import { GestioneUtenti } from './pages/GestioneUtenti';
import { SoggettiProponenti } from './pages/SoggettiProponenti';
import { SoggettoProponenteDetail } from './pages/SoggettoProponenteDetail';
import { EmailCampagne } from './pages/EmailCampagne';
import { EmailTemplates } from './pages/EmailTemplates';
import { GestioneTicket } from './pages/GestioneTicket';
import { AnalisiTicket } from './pages/AnalisiTicket';
import { TicketDetail } from './pages/TicketDetail';
import { GestioneDiario } from './pages/GestioneDiario';
import { GestioneFAQ } from './pages/GestioneFAQ';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/login" element={<LoginPage data-id="element-3" />} data-id="element-2" />
        <Route path="/register" element={<RegisterPage data-id="element-5" />} data-id="element-4" />
        <Route path="/" element={<LoginPage data-id="element-7" />} data-id="element-6" />
        <Route element={<Layout data-id="element-9" />} data-id="element-8">
          <Route path="/dashboard" element={<Dashboard data-id="element-11" />} data-id="element-10" />
          <Route path="/bandi" element={<Bandi data-id="element-13" />} data-id="element-12" />
          <Route path="/bandi/:id" element={<BandoDetail data-id="element-15" />} data-id="element-14" />
          <Route path="/candidature" element={<Candidature data-id="element-17" />} data-id="element-16" />
          <Route path="/candidature/:id" element={<CandidaturaDetail data-id="element-19" />} data-id="element-18" />
          <Route path="/valutatori" element={<GestioneValutatori data-id="element-21" />} data-id="element-20" />
          <Route path="/gestione-utenti" element={<GestioneUtenti data-id="element-23" />} data-id="element-22" />
          <Route path="/soggetti-proponenti" element={<SoggettiProponenti data-id="element-25" />} data-id="element-24" />
          <Route path="/soggetti-proponenti/dettaglio/:id" element={<SoggettoProponenteDetail data-id="element-27" />} data-id="element-26" />
          <Route path="/email/campagne" element={<EmailCampagne data-id="element-29" />} data-id="element-28" />
          <Route path="/email/templates" element={<EmailTemplates data-id="element-31" />} data-id="element-30" />
          <Route path="/ticket/tutti" element={<GestioneTicket data-id="element-33" />} data-id="element-32" />
          <Route path="/ticket/assegnati-a-te" element={<GestioneTicket data-id="element-35" />} data-id="element-34" />
          <Route path="/ticket/analisi" element={<AnalisiTicket data-id="element-37" />} data-id="element-36" />
          <Route path="/ticket/:id" element={<TicketDetail data-id="element-39" />} data-id="element-38" />
          <Route path="/diario" element={<GestioneDiario data-id="element-41" />} data-id="element-40" />
          <Route path="/faq" element={<GestioneFAQ data-id="element-43" />} data-id="element-42" />
        </Route>
      </Routes>
    </Router>;
}